<template>
	<div class="row">
		<rotina-list-toolbar modal-id="filtrosAvancadosAfiliados" :active-filters="quantidadeFiltrosAtivos" :can-create="false" @search="carregarAfiliados(0)" @apply="carregarAfiliados(0)" @clear="limparFiltrosAvancados">
			<template v-slot:actions><button type="button" class="btn btn-outline-primary" @click="carregarAfiliados(0)"><i class="far fa-sync me-1"></i>Atualizar</button></template>
			<template v-slot:quick><label><i class="far fa-search color-theme me-1"></i>Afiliado / CPF / CNPJ</label><input v-model.trim="pesquisa.termo" class="form-control" placeholder="Busque por nome ou documento" @keyup.enter="carregarAfiliados(0)" /></template>
			<template v-slot:advanced><div class="col-md-4"><label>Limite mínimo</label><input v-model.number="pesquisa.limiteMin" type="number" min="0" step="0.01" class="form-control" /></div><div class="col-md-4"><label>Valor utilizado mínimo</label><input v-model.number="pesquisa.gastosMin" type="number" min="0" step="0.01" class="form-control" /></div><div class="col-md-4"><label>Saldo disponível mínimo</label><input v-model.number="pesquisa.disponivelMin" type="number" step="0.01" class="form-control" /></div></template>
		</rotina-list-toolbar>
		<div v-if="false" id="search-nav" class="col-12 d-block btn-group dropup">
         <button type="button" class="btn btn-primary dropdown-toggle d-block d-lg-none" data-bs-toggle="dropdown" data-bs-auto-close="false" aria-expanded="false">
            <i class="far fa-search font-17 mx-auto"></i><i class="fal fa-times font-17 mx-auto"></i>
         </button>
         <div class="card mb-2 dropdown-menu dropdown-menu-left">
            <div class="card-body pb-0">
               <div class="row">
						<div class="col-sm mb-3">
							<div class="d-flex justify-content-between align-items-center h-100">
								<h5 class="mb-0">Afiliados (Convênio)</h5>
								<button type="button" class="btn btn-primary" @click="carregarAfiliados(0)">
									<i class="far fa-sync font-13"></i> Atualizar
								</button>
							</div>
						</div>
               </div>
            </div>
         </div>
      </div>

		<cadastro-grid
			:rows="pesquisa.resultados"
			:columns="gridColumns"
			:actions="gridActions"
			title="Afiliados com Convênio"
			empty-text="Nenhum afiliado encontrado."
			:total="pesquisa.total"
			:page="pesquisa.pagina"
			:size="pesquisa.tamanho"
			:showing-text="textoExibindo"
			@page-change="carregarAfiliados"
			@size-change="pesquisa.tamanho = $event; pesquisa.pagina = 0; carregarAfiliados(0)"
			@action="tratarAcaoGrid"
		>
			<template v-slot:cell-razaoSocialNome="{ row }">
				<div class="weight-500 limitador-1 text-uppercase">{{ row.razaoSocialNome || '-' }}</div>
				<div class="font-10 text-secondary limitador-1"><i class="far fa-id-card font-9 me-1"></i>{{ row.cnpjCpf || '-' }}</div>
			</template>
			<template v-slot:cell-limite="{ row }">
				<span class="text-dark">{{ formatarMoeda(row.convenio.limite) }}</span>
			</template>
			<template v-slot:cell-gastos="{ row }">
				<span class="text-danger fw-bold">{{ formatarMoeda(row.convenio.gastos) }}</span>
			</template>
			<template v-slot:cell-disponivel="{ row }">
				<span class="text-success fw-bold">{{ formatarMoeda(row.convenio.saldoDisponivel || (row.convenio.limite - row.convenio.gastos)) }}</span>
			</template>
		</cadastro-grid>

		<!-- Modal de Pagamento / Abatimento -->
		<div class="modal fade" id="modalPagamento" tabindex="-1" aria-labelledby="modalPagamentoLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header bg-theme text-white">
						<h5 class="modal-title" id="modalPagamentoLabel">Abater Limite - {{ afiliadoSelecionado?.razaoSocialNome }}</h5>
						<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="mb-3">
							<label>Limite Utilizado (Dívida)</label>
							<input type="text" class="form-control text-danger fw-bold" :value="formatarMoeda(afiliadoSelecionado?.convenio?.gastos)" disabled>
						</div>
						<div class="mb-3">
							<label>Valor a Abater</label>
							<input type="text" class="form-control" v-model.lazy="pagamento.valorPago" v-money="moneyFormat">
						</div>
						<div class="mb-3">
							<label>Observação</label>
							<textarea class="form-control" v-model="pagamento.observacao" rows="3" placeholder="Opcional"></textarea>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
						<button type="button" class="btn btn-primary" @click="registrarPagamento" :disabled="carregandoPagamento">Registrar Pagamento</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal Ver Compras -->
		<div class="modal fade" id="modalVerCompras" tabindex="-1" aria-labelledby="modalVerComprasLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content h-100">
					<div class="modal-header bg-theme text-white">
						<h5 class="modal-title" id="modalVerComprasLabel">Compras do Afiliado - {{ afiliadoSelecionado?.razaoSocialNome }}</h5>
						<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div v-if="compras.length === 0" class="text-center py-4">
							<i class="far fa-box-open font-40 text-muted mb-3"></i>
							<p>Nenhuma compra encontrada para este afiliado.</p>
						</div>
						<div class="table-responsive" v-else>
							<table class="table table-striped table-hover table-sm font-12 align-middle">
								<thead>
									<tr>
										<th>ID Venda</th>
										<th>Data</th>
										<th>Canal</th>
										<th>Situação</th>
										<th>Valor Total</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="compra in compras" :key="compra.id">
										<td>#{{ compra.id }}</td>
										<td>{{ formatarData(compra.dataHoraVenda || compra.createdAt) }}</td>
										<td>{{ compra.canal }}</td>
										<td>{{ compra.status }}</td>
										<td class="fw-bold">{{ formatarMoeda(compra.valorTotal) }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import $ from 'jquery'
import { mapState } from 'vuex'
import cadastroGrid from '@/components/cadastros/CadastroGrid.vue'
import { VMoney } from 'v-money'

export default {
	name: 'AfiliadosConvenio',
	components: { cadastroGrid },
	directives: { money: VMoney },
	data() {
		return {
			pesquisa: { termo: '', limiteMin: null, gastosMin: null, disponivelMin: null, resultados: [], pagina: 0, tamanho: 20, total: 0 },
			afiliadoSelecionado: null,
			compras: [],
			pagamento: { valorPago: 0, observacao: '' },
			carregandoPagamento: false,
			moneyFormat: { decimal: ',', thousands: '.', prefix: 'R$ ', suffix: '', precision: 2, masked: false }
		}
	},
	computed: {
		quantidadeFiltrosAtivos() { return [this.pesquisa.limiteMin, this.pesquisa.gastosMin, this.pesquisa.disponivelMin].filter(value => value !== '' && value !== null && value !== undefined).length },
		...mapState({ urlRest: state => state.urlRest, empresa: state => state.empresa }),
		textoExibindo() {
			const total = this.pesquisa.total
			const page = this.pesquisa.pagina
			const size = this.pesquisa.tamanho
			if (total === 0) return '0'
			return `${page * size + 1}-${Math.min((page + 1) * size, total)}`
		},
		gridColumns() {
			return [
				{ key: 'razaoSocialNome', label: 'Nome / CPF' },
				{ key: 'limite', label: 'Limite', width: '150px' },
				{ key: 'gastos', label: 'Utilizado (Dívida)', width: '150px' },
				{ key: 'disponivel', label: 'Disponível', width: '150px' }
			]
		},
		gridActions() {
			return [
				{ icon: 'far fa-eye', name: 'ver-compras', tooltip: 'Ver Compras', color: 'text-primary' },
				{ icon: 'far fa-hand-holding-usd', name: 'pagar', tooltip: 'Abater Limite', color: 'text-success' }
			]
		}
	},
	mounted() {
		this.carregarAfiliados(0)
	},
	methods: {
		limparFiltrosAvancados() { Object.assign(this.pesquisa, { limiteMin: null, gastosMin: null, disponivelMin: null }); this.carregarAfiliados(0) },
		formatarMoeda(valor) {
			if (valor == null) return 'R$ 0,00';
			return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
		},
		formatarData(dataStr) {
			if (!dataStr) return '-';
			const date = new Date(dataStr);
			return date.toLocaleString('pt-BR');
		},
		carregarAfiliados(pagina) {
			this.pesquisa.pagina = pagina == null ? this.pesquisa.pagina + 1 : pagina
			this.$store.dispatch('alternarTelaCarregamento', 1)

			this.$axios.get(this.urlRest + 'convenio/afiliados', {
				headers: { 'X-Company-Id': this.empresa.id },
				params: { page: this.pesquisa.pagina, size: this.pesquisa.tamanho, termo: this.pesquisa.termo || undefined, limiteMin: this.pesquisa.limiteMin ?? undefined, gastosMin: this.pesquisa.gastosMin ?? undefined, disponivelMin: this.pesquisa.disponivelMin ?? undefined }
			}).then(res => {
				const data = res.data
				this.pesquisa.resultados = data.content || []
				this.pesquisa.total = data.totalElements || data.total || this.pesquisa.resultados.length
			}).catch(() => {
				this.$toast.fire({ icon: 'error', title: 'Erro ao carregar afiliados.' })
			}).finally(() => this.$store.dispatch('alternarTelaCarregamento', -1))
		},
		tratarAcaoGrid(acao, row) {
			this.afiliadoSelecionado = row
			if (acao === 'ver-compras') {
				this.carregarCompras(row.id)
			} else if (acao === 'pagar') {
				this.pagamento = { valorPago: 0, observacao: '' }
				$('#modalPagamento').modal('show')
			}
		},
		carregarCompras(pessoaId) {
			this.$store.dispatch('alternarTelaCarregamento', 1)
			this.$axios.get(`${this.urlRest}convenio/afiliados/${pessoaId}/compras`, {
				headers: { 'X-Company-Id': this.empresa.id }
			}).then(res => {
				this.compras = res.data || []
				$('#modalVerCompras').modal('show')
			}).catch(() => {
				this.$toast.fire({ icon: 'error', title: 'Erro ao carregar compras.' })
			}).finally(() => this.$store.dispatch('alternarTelaCarregamento', -1))
		},
		registrarPagamento() {
			let valorReal = this.pagamento.valorPago;
			if (typeof valorReal === 'string') {
				valorReal = parseFloat(valorReal.replace('R$ ', '').replace(/\./g, '').replace(',', '.'));
			}
			if (!valorReal || valorReal <= 0) {
				this.$toast.fire({ icon: 'warning', title: 'O valor deve ser maior que zero.' })
				return
			}
			if (valorReal > (this.afiliadoSelecionado.convenio.gastos || 0)) {
				this.$toast.fire({ icon: 'warning', title: 'O valor pago não pode ser maior que o limite utilizado (dívida).' })
				return
			}

			this.carregandoPagamento = true
			this.$store.dispatch('alternarTelaCarregamento', 1)
			
			this.$axios.post(`${this.urlRest}convenio/pagar/${this.afiliadoSelecionado.id}`, {
				valorPago: valorReal,
				observacao: this.pagamento.observacao
			}, {
				headers: { 'X-Company-Id': this.empresa.id }
			}).then(() => {
				this.$toast.fire({ icon: 'success', title: 'Pagamento registrado com sucesso!' })
				$('#modalPagamento').modal('hide')
				this.carregarAfiliados(this.pesquisa.pagina)
			}).catch(() => {
				this.$toast.fire({ icon: 'error', title: 'Erro ao registrar pagamento.' })
			}).finally(() => {
				this.carregandoPagamento = false
				this.$store.dispatch('alternarTelaCarregamento', -1)
			})
		}
	}
}
</script>
